import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Description } from '@radix-ui/react-toast';

const ToastDescription = React__default.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (jsx(Description, Object.assign({ ref: ref, className: className }, props, { children: children })));
});
ToastDescription.displayName = "ToastDescription";

export { ToastDescription };
